export { default, loader } from "~/components/product/CountdownProductShelf"

export function LoadingFallback() {
    return <div className='h-[1040px] md:h-[1143px] lg:h-[740px] animate-pulse bg-gray-200' />
}
